export default "__VITE_ASSET__AbhJhklo__"